import makeUseCellCopyAction, {
  UseCellCopyActionProps,
} from "ds/components/Table/helpers/makeUseCellCopyAction";

import useModulesAnalytics from "../useModulesAnalytics";

const useCellCopyAction = (props: UseCellCopyActionProps) => {
  return makeUseCellCopyAction({ trackAnalytics: useModulesAnalytics() })(props);
};

export default useCellCopyAction;
